import {
  SLR_CONTRACT_START,
  SLR_CONTRACT_END,
  SLR_CONTRACT_BY_ID,
  SLR_POSTED_LOADING_START,
  SLR_POSTED_LOADING_END,
  SLR_POSTED_RESULTS_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const SLRTypes = (type, data) => ({ type, data });

// ─── Contract CRUD ────────────────────────────────────────────────────────────

export const getSalesRebateContract = (id, isPendingContract) => {
  return (dispatch) => {
    dispatch(SLRTypes(SLR_CONTRACT_START));
    getSalesRebateContractAPI(id, isPendingContract)
      .then((response) => {
        dispatch(SLRTypes(SLR_CONTRACT_BY_ID, response.data.response));
        dispatch(SLRTypes(SLR_CONTRACT_END));
      })
      .catch(() => dispatch(SLRTypes(SLR_CONTRACT_END)));
  };
};

const getSalesRebateContractAPI = (id, isPendingContract) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  const BASE_API = '/sales-rebate/contract';
  const url = isPendingContract ? `${BASE_API}/${id}?is_pending_contract=true` : `${BASE_API}/${id}`;
  return axios.get(url, { headers });
};

export const submitSalesRebateContract = (type, id, data) => {
  return async (dispatch) => {
    dispatch(SLRTypes(SLR_CONTRACT_START));
    try {
      const response = await submitSalesRebateContractAPI(type, id, data);
      dispatch(SLRTypes(SLR_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SLRTypes(SLR_CONTRACT_END));
      if (error.response?.data?.log_number) return { success: false };
      throw error;
    }
  };
};

const submitSalesRebateContractAPI = (type, id, data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'edit') return axios.put('/sales-rebate/contract', data, { headers });
  return axios.post('/sales-rebate/contract', data, { headers });
};

export const deleteSalesRebateContract = (id) => {
  return async (dispatch) => {
    dispatch(SLRTypes(SLR_CONTRACT_START));
    try {
      const response = await deleteSalesRebateContractAPI(id);
      dispatch(SLRTypes(SLR_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || 'Deleted successfully');
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SLRTypes(SLR_CONTRACT_END));
      throw error;
    }
  };
};

const deleteSalesRebateContractAPI = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.delete(`/sales-rebate/contract/${id}`, { headers });
};

// ─── Posted Results ───────────────────────────────────────────────────────────

export const salesRebatePostedResults = (data, apiPath, page) => {
  return async (dispatch) => {
    dispatch(SLRTypes(SLR_POSTED_LOADING_START));
    try {
      const response = await salesRebatePostedResultsApi(data, apiPath);
      dispatch(SLRTypes(SLR_POSTED_LOADING_END));
      const logNumber = response?.data?.log_number;
      const resultData = response?.data?.result || response?.data?.response;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (!hasError && resultData && resultData.length > 0) {
          dispatch(salesRebatePostedResultsSuccess({ ...response.data, result: resultData }));
          history.push(`/sales-rebate-${page}-results`);
        }
        return { success: !hasError, response };
      } else {
        if (resultData && resultData.length > 0) {
          dispatch(salesRebatePostedResultsSuccess({ ...response.data, result: resultData }));
          history.push(`/sales-rebate-${page}-results`);
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SLRTypes(SLR_POSTED_LOADING_END));
      if (error?.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const salesRebatePostedResultsApi = (data, apiPath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apiPath, data, { headers });
};

export const salesRebatePostedResultsSuccess = (data) => {
  return {
    type: SLR_POSTED_RESULTS_SUCCESS,
    data,
  };
};
